export default "__VITE_ASSET__C0Vxe0tK__"